import mutations from "./mutations";
import * as actions from "./actions";

let state = {
    items: [],
    settings: {
        is_billing_reimb_visible: true
    }
};

export default {mutations, actions, state}
